<template>
  <div class="user-center">
    <van-form @submit="onSubmit" ref="validForm" class="edit-pwd">
      <van-field
        v-model="nickname"
        name="昵称"
        label="昵称"
        placeholder="请输入新的昵称"
        :rules="[{ required: true, message: '' }]"
      />
      <div class="sumbit-btn" @click="onSubmit">确定</div>
    </van-form>
    <div class="back-btn" @click="$router.back()">返回</div>
  </div>
</template>

<script>
import { updateNickname } from '@/api/user/index.js'
import '@/assets/_variable.scss'
import { Toast } from 'vant'
export default {
  name: 'UserCenter',
  data() {
    return {
      nickname: '',
    }
  },
  created() {},
  methods: {
    onSubmit() {
      this.$refs.validForm
        .validate()
        .then(() => {
          //do
          updateNickname({
            nickName: this.nickname,
          }).then((res) => {
            console.log(res)
            Toast.success('提交成功！')
            this.$router.push('/user/userCenter')
          })
        })
        .catch(() => {
          console.log('failed')
        })
    },
  },
  mounted() {},
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.user-center {
  width: 100%;
  padding: 20px 0;
  height: 100%;
  background: url('../../assets/img/notice-bg.png') top center no-repeat;
  background-size: contain;
  .edit-pwd {
    margin: 0 20px;
    .van-cell {
      border: 1px solid #e6e6e6;
      border-radius: 4px;
      height: 40px;
      line-height: 18px;
      margin-bottom: 10px;
    }
    .sumbit-btn {
      margin-top: 30px;
      width: 100%;
      height: 40px;
      line-height: 40px;
      text-align: center;
      background-color: #dd3349;
      color: #fff;
      font-size: 16px;
      font-weight: 400;
      box-shadow: 0 0 15px #dd3349;
      border-radius: 4px;
      margin-bottom: 50px;
    }
  }
}
</style>
